import { render } from "./addons.vue?vue&type=template&id=26883a7e"
import script from "./addons.vue?vue&type=script&lang=js"
export * from "./addons.vue?vue&type=script&lang=js"

import "./addons.vue?vue&type=style&index=0&id=26883a7e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__